
    <template>
      <section class="relax-doc">
        <h1>Notice 通知</h1>
<blockquote>
<p>全局展示通知提醒信息</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>最简单的用法，<code>4.5</code> 秒后自动关闭。</p>
</blockquote>
<demo-block>
        <p><code>notice</code> 会被挂载在 <code>vue</code> 全局属性中, 当然也可以引入 <code>RelaxPlus</code> 直接使用</p>

        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
   &lt;x-button type='primary' @click=&quot;handerClick&quot;&gt;显示普通通知&lt;/x-button&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$notice} = instance.appContext.config.globalProperties
      const handerClick = () =&gt; {
        $notice({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了'
        })
      }
      return {
        handerClick
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="tong-zhi-lei-xing"><a class="header-anchor" href="#tong-zhi-lei-xing"></a> 通知类型</h2>
<blockquote>
<p>不同的提示状态：信息、成功、警告、错误</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
   &lt;x-button type=&quot;info&quot; plain @click=&quot;open1&quot;&gt;打开通知提示&lt;/x-button&gt;
   &lt;x-button type=&quot;success&quot; plain  @click=&quot;open2&quot;&gt;显示成功提示&lt;/x-button&gt;
   &lt;x-button type=&quot;warning&quot; plain  @click=&quot;open3&quot;&gt;显示警告提示&lt;/x-button&gt;
   &lt;x-button type=&quot;danger&quot; plain  @click=&quot;open4&quot;&gt;显示错误提示&lt;/x-button&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$notice} = instance.appContext.config.globalProperties

      const open1 = () =&gt; {
        $notice.info({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了'
        })
      }
      const open2 = () =&gt; {
        $notice.success({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了'
        })
      }
      const open3 = () =&gt; {
        $notice.warning({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了'
        })
      }
      const open4 = () =&gt; {
        $notice.error({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了'
        })
      }

      return {
        open1,
        open2,
        open3,
        open4,
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="jin-xian-shi-biao-ti"><a class="header-anchor" href="#jin-xian-shi-biao-ti"></a> 仅显示标题</h2>
<blockquote>
<p><code>title</code> 为必填项</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
   &lt;x-button type=&quot;primary&quot; plain @click=&quot;handerClick&quot;&gt;打开提醒(仅标题)&lt;/x-button&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$notice} = instance.appContext.config.globalProperties
      const handerClick = () =&gt; {
        $notice.warning({
          title: '10秒后自动关闭',
          duration: 10
        })
      }
      return {
        handerClick
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="zi-ding-yi-tu-biao"><a class="header-anchor" href="#zi-ding-yi-tu-biao"></a> 自定义图标</h2>
<blockquote>
<p>填写 <code>icon</code> 属性，可以使用自己喜欢的图标</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo3 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
   &lt;x-button type=&quot;primary&quot; plain @click=&quot;handerClick1&quot;&gt;显示自定义图标&lt;/x-button&gt;
   &lt;x-button type=&quot;primary&quot; plain @click=&quot;handerClick2&quot;&gt;显示自定义图标&lt;/x-button&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$notice} = instance.appContext.config.globalProperties

      const handerClick1 = () =&gt; {
        $notice.error({
          icon: 'x-icon-heart-on',
          title: '落叶的一生，只是为了归根吗？',
          duration: 20
        })
      }

      const handerClick2 = () =&gt; {
        $notice.info({
          icon: 'x-icon-cloud-rain',
          title: '面对疾风吧！',
          duration: 20
        })
      }

      return {
        handerClick1,
        handerClick2,
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="shou-dong-guan-bi"><a class="header-anchor" href="#shou-dong-guan-bi"></a> 手动关闭</h2>
<blockquote>
<p>自定义时长，为 <code>0</code> 则不自动关闭</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo4 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
   &lt;x-button type=&quot;primary&quot; plain @click=&quot;handerClick&quot;&gt;手动关闭&lt;/x-button&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$notice} = instance.appContext.config.globalProperties
      const handerClick = () =&gt; {
        $notice.success({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了',
          duration: 0
        })
      }
      return {
        handerClick
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createBlock(_component_x_button, {
    type: "primary",
    onClick: _ctx.handerClick
  }, {
    default: _withCtx(() => [
      _createTextVNode("显示普通通知")
    ]),
    _: 1
  }, 8, ["onClick"]))
}
  
    
        const {getCurrentInstance} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$notice} = instance.appContext.config.globalProperties
      const handerClick = () => {
        $notice({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了'
        })
      }
      return {
        handerClick
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "info",
      plain: "",
      onClick: _ctx.open1
    }, {
      default: _withCtx(() => [
        _createTextVNode("打开通知提示")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "success",
      plain: "",
      onClick: _ctx.open2
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示成功提示")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "warning",
      plain: "",
      onClick: _ctx.open3
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示警告提示")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "danger",
      plain: "",
      onClick: _ctx.open4
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示错误提示")
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64))
}
  
    
        const {getCurrentInstance} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$notice} = instance.appContext.config.globalProperties

      const open1 = () => {
        $notice.info({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了'
        })
      }
      const open2 = () => {
        $notice.success({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了'
        })
      }
      const open3 = () => {
        $notice.warning({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了'
        })
      }
      const open4 = () => {
        $notice.error({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了'
        })
      }

      return {
        open1,
        open2,
        open3,
        open4,
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createBlock(_component_x_button, {
    type: "primary",
    plain: "",
    onClick: _ctx.handerClick
  }, {
    default: _withCtx(() => [
      _createTextVNode("打开提醒(仅标题)")
    ]),
    _: 1
  }, 8, ["onClick"]))
}
  
    
        const {getCurrentInstance} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$notice} = instance.appContext.config.globalProperties
      const handerClick = () => {
        $notice.warning({
          title: '10秒后自动关闭',
          duration: 10
        })
      }
      return {
        handerClick
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      onClick: _ctx.handerClick1
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示自定义图标")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      onClick: _ctx.handerClick2
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示自定义图标")
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64))
}
  
    
        const {getCurrentInstance} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$notice} = instance.appContext.config.globalProperties

      const handerClick1 = () => {
        $notice.error({
          icon: 'x-icon-heart-on',
          title: '落叶的一生，只是为了归根吗？',
          duration: 20
        })
      }

      const handerClick2 = () => {
        $notice.info({
          icon: 'x-icon-cloud-rain',
          title: '面对疾风吧！',
          duration: 20
        })
      }

      return {
        handerClick1,
        handerClick2,
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo4": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createBlock(_component_x_button, {
    type: "primary",
    plain: "",
    onClick: _ctx.handerClick
  }, {
    default: _withCtx(() => [
      _createTextVNode("手动关闭")
    ]),
    _: 1
  }, 8, ["onClick"]))
}
  
    
        const {getCurrentInstance} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$notice} = instance.appContext.config.globalProperties
      const handerClick = () => {
        $notice.success({
          title: 'Notice 通知',
          content: '全新的 Notice 通知组件，对比老版本动画更加流畅，细腻，柔和，加入进度条倒计时指示，根本停不下来，太酷了',
          duration: 0
        })
      }
      return {
        handerClick
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  